import { make } from 'vuex-pathify';

const state = {
    title: 'Welcome to LifeSkills Mobile!',
    complete: false,
    sticker: {
        text: 'LS Logo',
        earned: false,
        image: require('@/assets/stickers/stickers_0000_ls.png')
    },
    bonusSticker: false,
    trophy: false
};
const getters = make.getters(state);
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
